import { Modal, SubmitButton } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React from "react";
import { NoTranslate } from "../../Common/NoTranslate";

interface ConfirmWaiverSwapModalInterface {
    isOpen: boolean;
    swapFromGuest: string;
    swapToGuest: string;
    onConfirm: () => void;
    onClose: () => void;
}

export const ConfirmWaiverSwapModal = ({
    isOpen,
    swapFromGuest,
    swapToGuest,
    onClose,
    onConfirm,
}: ConfirmWaiverSwapModalInterface) => {
    return (
        <Modal isOpen={isOpen}>
            <Modal.Header>Confirm Waiver Swap</Modal.Header>
            <Modal.Body>
                <div className="space-y-4">
                    <p className="p1">
                        This action will unlink the selected waiver from <NoTranslate>{swapFromGuest}</NoTranslate> and
                        then assign it to <NoTranslate>{swapToGuest}</NoTranslate>. Please confirm.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <SubmitButton color="danger" onClick={onConfirm}>
                    Confirm
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};
